import React, {Fragment} from "react";
import PropTypes from "prop-types";
import SecurityQuestionInputComponent, {
    PROP_NAME_CONFIRM_SEC_ANS,
    PROP_NAME_SEC_ANS,
    PROP_NAME_SEC_Q
} from "./SecurityQuestionInputComponent";
import {isNotBlank, trimToEmpty} from "../../../util/StringUtil";
import {setupOnExtractData} from "../../../util/FormUtil";

const ERROR_SEC_Q_UNIQUE = "Security question must be unique";
export const PROP_NAME_SEC_Q1 = PROP_NAME_SEC_Q + "1";
export const PROP_NAME_SEC_Q2 = PROP_NAME_SEC_Q + "2";
export const PROP_NAME_SEC_Q3 = PROP_NAME_SEC_Q + "3";

export const PROP_NAME_SEC_ANS1 = PROP_NAME_SEC_ANS + "1";
export const PROP_NAME_SEC_ANS2 = PROP_NAME_SEC_ANS + "2";
export const PROP_NAME_SEC_ANS3 = PROP_NAME_SEC_ANS + "3";

class SecurityQuestionsInputComponent extends React.Component {

    constructor(props){
        super(props);
        this.state = {};
        this.showThirdSecurityQuestion = this.showThirdSecurityQuestion.bind(this);
        this.uniqueQuestionsValidation = this.uniqueQuestionsValidation.bind(this);
        this.getMeta = this.getMeta.bind(this);
        this.findFormStateParam = this.findFormStateParam.bind(this);
        this.addIfNotExist = this.addIfNotExist.bind(this);
        this.checkUnique = this.checkUnique.bind(this);
        this.removeUniqueErrorIfPass = this.removeUniqueErrorIfPass.bind(this);
        this.setExtractSecQnA1 = this.setExtractSecQnA1.bind(this);
        this.setExtractSecQnA2 = this.setExtractSecQnA2.bind(this);
        this.setExtractSecQnA3 = this.setExtractSecQnA3.bind(this);
        this.extractData = this.extractData.bind(this);
        this.setShowSecurityQnA = this.setShowSecurityQnA.bind(this);
        this.clearSecurityQnA = this.clearSecurityQnA.bind(this);
        this.showSecurityQnA = this.showSecurityQnA.bind(this);
        this.setHideSecurityQnAPrompt = this.setHideSecurityQnAPrompt.bind(this);
        this.hideSecurityQnAPrompt = this.hideSecurityQnAPrompt.bind(this);
        this.hideSecurityQnAPromptAndShowSecurityQnA = this.hideSecurityQnAPromptAndShowSecurityQnA.bind(this);
    }

    showThirdSecurityQuestion(e){
        if (e) {
            e.preventDefault();
        }
        this.setState(state => ({...state, showThirdSecurityQuestion: true}));
    }

    componentDidMount() {
        const {data={}} = this.props;
        const labelQ3 = PROP_NAME_SEC_Q + "3";
        if (isNotBlank(data[labelQ3])){
            this.showThirdSecurityQuestion();
        }
        setupOnExtractData(this);

        if (this.hasData(data)){
            this.showSecurityQnA();
            this.hideSecurityQnAPrompt();
        }
    }

    hasData(data){
        const keys = Object.keys(data);
        for (let i = 0; i < keys.length; i++){
            const key = keys[i];
            const value = data[key];
            if ((key.startsWith(PROP_NAME_SEC_Q) || key.startsWith(PROP_NAME_SEC_ANS) || key.startsWith(PROP_NAME_CONFIRM_SEC_ANS)) && value){
                return true;
            }
        }
        return false;
    }

    uniqueQuestionsValidation(curData, curMetadata, formStateParams){
        const labelQ1 = PROP_NAME_SEC_Q1;
        const labelQ2 = PROP_NAME_SEC_Q2;
        const labelQ3 = PROP_NAME_SEC_Q3;

        const curQ1 = trimToEmpty(curData[labelQ1]);
        const curQ2 = trimToEmpty(curData[labelQ2]);
        const curQ3 = trimToEmpty(curData[labelQ3]);

        const q1Meta = this.getMeta(labelQ1, curMetadata, formStateParams);
        const q2Meta = this.getMeta(labelQ2, curMetadata, formStateParams);
        const q3Meta = this.getMeta(labelQ3, curMetadata, formStateParams);

        this.checkUnique(curQ1, curQ2, q1Meta, q2Meta, labelQ1, labelQ2, formStateParams);
        this.checkUnique(curQ1, curQ3, q1Meta, q3Meta, labelQ1, labelQ3, formStateParams);
        this.checkUnique(curQ2, curQ3, q2Meta, q3Meta, labelQ2, labelQ3,formStateParams);

        // Now, for any questions fields who don't have the unique error, but previously
        // has the unique error, we need to remove the message.
        this.removeUniqueErrorIfPass(labelQ1, curMetadata, formStateParams);
        this.removeUniqueErrorIfPass(labelQ2, curMetadata, formStateParams);
        this.removeUniqueErrorIfPass(labelQ3, curMetadata, formStateParams);

    }

    removeUniqueErrorIfPass(property, curMetadata, formStateParams){
        if (! this.findFormStateParam(property, formStateParams)){
            // There are no entries in formStateParams, check metadata
            const fieldMetadata = curMetadata[property];
            if (fieldMetadata && ! fieldMetadata.valid && fieldMetadata.message === ERROR_SEC_Q_UNIQUE) {
                // Alright, metadata said the field is not valid due to the unique question error,
                // since it is not specified in formStateParams, it means that the field is now valid.
                // We need to remove the error message.
                formStateParams.push({property, metadata: {...fieldMetadata, valid: true, message: null}})
            }
        }
    }

    getMeta(property, curMetadata, formStateParams){
        let result = this.findFormStateParam(property, formStateParams);
        if (result){
            return result.metadata;
        }
        result = curMetadata[property];
        if (result){
            return result;
        }
        return {};
    }

    findFormStateParam(property, formStateParams){
        for (let i = 0; i < formStateParams.length; i++){
            const formStateParam = formStateParams[i];
            if (formStateParam.property === property){
                return formStateParam;
            }
        }
        return null;
    }

    addIfNotExist(property, metadata, formStateParams){
        if (! this.findFormStateParam(property, formStateParams)){
            formStateParams.push({property, metadata});
        }
    }

    checkUnique(qA, qB, metaA, metaB, qALabel, qBLabel, formStateParams){
        if (qA.length && qB.length && qA.trim().toLowerCase() === qB.trim().toLowerCase()){
            metaA.valid = false;
            metaA.message = ERROR_SEC_Q_UNIQUE;
            metaB.valid = false;
            metaB.message = ERROR_SEC_Q_UNIQUE;
            this.addIfNotExist(qALabel, metaA, formStateParams);
            this.addIfNotExist(qBLabel, metaB, formStateParams);
        }
    }

    setExtractSecQnA1(extractFunction){
        this.extractSecQnA1 = extractFunction;
    }

    setExtractSecQnA2(extractFunction){
        this.extractSecQnA2 = extractFunction;
    }

    setExtractSecQnA3(extractFunction){
        this.extractSecQnA3 = extractFunction;
    }

    extractData(){
        const {required, data} = this.props;
        const {showSecurityQnA} = data;
        if (required || showSecurityQnA) {
            const result = {
                ...this.extractSecQnA1(),
                ...this.extractSecQnA2()
            };
            const q3 = this.extractSecQnA3 ? this.extractSecQnA3() : null;
            if (q3) {
                return {...result, ...q3};
            } else {
                return result;
            }
        } else {
            return null;
        }
    }

    setShowSecurityQnA(showSecurityQnA){
        const {setFormState, onSetShowSecurityQnA} = this.props;
        setFormState({property: "showSecurityQnA", data: showSecurityQnA});
        if (onSetShowSecurityQnA){
            onSetShowSecurityQnA(showSecurityQnA);
        }
    }

    showSecurityQnA(){
        this.setShowSecurityQnA(true);
    }

    clearSecurityQnA(e){
        if (e) {
            e.preventDefault();
        }
        const {metadata, setFormState} = this.props;
        this.setShowSecurityQnA(false);
        this.setHideSecurityQnAPrompt(false);
        const keys = Object.keys(metadata);
        for (let i = 0; i < keys.length; i++){
            const key = keys[i];
            if (
                key.indexOf(PROP_NAME_SEC_Q) === 0 ||
                key.indexOf(PROP_NAME_SEC_ANS) === 0 ||
                key.indexOf(PROP_NAME_CONFIRM_SEC_ANS) === 0
            ){
                // reset the metadata to valid for the sec q n a keys
                setFormState({property: key, metadata: {valid: true, message: null, dirty: false}})
            }
        }

    }

    setHideSecurityQnAPrompt(hideSecurityQnAPrompt){
        const {setFormState} = this.props;
        setFormState({property: "hideSecurityQnAPrompt", data: hideSecurityQnAPrompt});
    }

    hideSecurityQnAPrompt(){
        this.setHideSecurityQnAPrompt(true);
    }

    hideSecurityQnAPromptAndShowSecurityQnA(){
        this.hideSecurityQnAPrompt();
        this.showSecurityQnA();
    }

    render(){
        const {data, metadata, setFormState, userDataInit, required=true} = this.props;
        const {showThirdSecurityQuestion} = this.state;
        const {showSecurityQnA, hideSecurityQnAPrompt} = data;
        return (
            <Fragment>
                {
                    ! required && ! hideSecurityQnAPrompt &&
                    <div className="panel--raised">
                        <p>
                            You can optionally provide us with <em>Security Questions and Answers</em>. If you provide
                            this information, CME Group can use it to verify your identity when you call for
                            support, in case email is not available. Would you like to provide it now?
                        </p>
                        <div className="text--right">
                            <button className="btn btn--large push-half--left" onClick={this.hideSecurityQnAPromptAndShowSecurityQnA}>Let's do it</button>
                        </div>
                    </div>
                }

                {
                    (required || showSecurityQnA) &&
                    <div>
                        <SecurityQuestionInputComponent
                            data={data}
                            metadata={metadata}
                            setFormState={setFormState}
                            userDataInit={userDataInit}
                            index={1}
                            required={true}
                            extraValidation={this.uniqueQuestionsValidation}
                            onExtractData={this.setExtractSecQnA1}
                        />

                        <SecurityQuestionInputComponent
                            data={data}
                            metadata={metadata}
                            setFormState={setFormState}
                            userDataInit={userDataInit}
                            index={2}
                            required={true}
                            extraValidation={this.uniqueQuestionsValidation}
                            onExtractData={this.setExtractSecQnA2}
                        />
                        {
                            showThirdSecurityQuestion ?
                                <SecurityQuestionInputComponent
                                    data={data}
                                    metadata={metadata}
                                    setFormState={setFormState}
                                    userDataInit={userDataInit}
                                    index={3}
                                    required={false}
                                    extraValidation={this.uniqueQuestionsValidation}
                                    onExtractData={this.setExtractSecQnA3}
                                /> :
                                <div>
                                    <a href="#" onClick={this.showThirdSecurityQuestion}>+ add another question</a>
                                </div>
                        }
                        {
                            ! required && showSecurityQnA &&
                            <div>
                                <a href="#" onClick={this.clearSecurityQnA}>- I change my mind. I will provide the <em>Security Questions and Answers</em> later.</a>
                            </div>
                        }
                    </div>
                }
            </Fragment>
        );
    }

}

SecurityQuestionsInputComponent.propTypes = {
    data: PropTypes.object.isRequired,
    metadata: PropTypes.object.isRequired,
    setFormState: PropTypes.func.isRequired,
    userDataInit: PropTypes.object.isRequired,
    required: PropTypes.bool,
    onExtractData: PropTypes.func
};

export default SecurityQuestionsInputComponent;